const mouth = "mouth";
const eyes = "eyes";
const hairs = "hairs";
const body = "body";
const bottoms = "bottoms";

export default { mouth, eyes, hairs, body, bottoms };
